module.exports = __webpack_public_path__ + "static/media/monkeyisland.9b2eadec.gif";